"use client";

import { useEffect } from "react";

const MESSAGE_DISPLAY_DURATION_MS = 4000;

import { useInfoMessage } from "@/providers/info-message-provider";
import { InfoMessage } from "../status-message/info-message";

export function InfoMessageRenderer() {
  const { message, handleSetMessage } = useInfoMessage();

  useEffect(() => {
    if (!message) {
      return;
    }

    setTimeout(() => {
      if (message.type !== "error") {
        handleSetMessage(null);
      }
    }, MESSAGE_DISPLAY_DURATION_MS);
  }, [message, handleSetMessage]);

  if (!message) {
    return null;
  }
  return (
    <div className="mt-4">
      <InfoMessage
        translationChunkName={message.translationChunkName}
        translationFieldName={message.translationFieldName}
        type={message.type}
      />
    </div>
  );
}
